<template>
  <div class="ownper_left">
    <!--<div class="nav_logo" @click="$router.push('/')">-->
    <!--<img :src="config.logo" :alt="config.site_title" style="width:180px;" class="pointer">-->
    <!--</div>-->

    <!--<el-menu
        ref="leftMenu"
        :default-active="$route.path"
        class="el-menu-vertical-demo"
        @close="handleClose"
        :router="true">
        <el-menu-item index="/" :route="{path:'/#home'}">
            <i class="el-icon-menu"></i>
            <span slot="title">用户中心</span>
        </el-menu-item>
        &lt;!&ndash;<el-submenu index="2">
            <template slot="title">
                <i class="el-icon-tickets"></i>
                <span>资源中心</span>
            </template>
            <el-menu-item-group>
                <el-menu-item  v-if="profile.is_new!==1" index="/resource/news" :route="{path:'/resource/news'}">软文推广</el-menu-item>
                <el-menu-item index="/resource/xhs" :route="{path:'/resource/xhs'}">小红书</el-menu-item>
                <el-menu-item index="/resource/video" :route="{path:'/resource/video'}">短视频</el-menu-item>
                <el-menu-item index="/resource/woa" :route="{path:'/resource/woa'}">微信公众号</el-menu-item>
                <el-menu-item index="/resource/weibo" :route="{path:'/resource/weibo'}">新浪微博</el-menu-item>
                <el-menu-item index="/resource/live" :route="{path:'/resource/live'}">网红直播</el-menu-item>
                &lt;!&ndash;<el-menu-item index="/resource/flow" :route="{path:'/resource/flow'}">信息流</el-menu-item>&ndash;&gt;
            </el-menu-item-group>
        </el-submenu>&ndash;&gt;
        <el-submenu index="1" v-if="profile.is_new!==1" :show-timeout="1">
            <template slot="title">
                <i class="el-icon-edit"></i>
                <span>软文发布</span>
            </template>
            <el-menu-item-group>
                <el-menu-item index="/own/manuscripts/create/news" :route="{path:'/own/manuscripts/create/news'}">文章发布</el-menu-item>
                <el-menu-item index="/own/news_order" :route="{path:'/own/news_order'}">文章列表</el-menu-item>
            </el-menu-item-group>
        </el-submenu>
        <el-menu-item index="/cart" :route="{path:'/cart?taxonomy=woa'}">
            <i class="el-icon-goods"></i>
            <span slot="title">购物车</span>
        </el-menu-item>
        <el-menu-item index="/own/order" :route="{path:'/own/order'}">
            <i class="el-icon-document"></i>
            <span slot="title">订单中心</span>
        </el-menu-item>
        <el-menu-item index="/own/manuscripts" :route="{path:'/own/manuscripts'}">
            <i class="el-icon-setting"></i>
            <span slot="title">稿件管理</span>
        </el-menu-item>
        <el-menu-item index="/own/manuscripts/copy_write" :route="{path:'/own/manuscripts/copy_write'}">
            <i class="el-icon-edit-outline"></i>
            <span slot="title">稿件代写</span>
        </el-menu-item>
        <el-submenu index="6">
            <template slot="title">
                <i class="el-icon-sort"></i>
                <span>充值与消费</span>
            </template>
            <el-menu-item-group>
                <el-menu-item index="/recharge_center" :route="{path:'/recharge_center'}">充值中心</el-menu-item>
                <el-menu-item index="/own/finance/transaction" :route="{path:'/own/finance/transaction'}">交易流水</el-menu-item>
                &lt;!&ndash;<el-menu-item index="/own/finance/invoice" :route="{path:'/own/finance/invoice'}">申请发票</el-menu-item>&ndash;&gt;
                <el-menu-item index="/own/finance/invoice_list" :route="{path:'/own/finance/invoice_list'}">发票列表</el-menu-item>
                <el-menu-item index="/own/finance/invoice_info_list" :route="{path:'/own/finance/invoice_info_list'}">发票信息审核</el-menu-item>
            </el-menu-item-group>
        </el-submenu>
        <el-submenu index="7">
            <template slot="title">
                <i class="el-icon-tickets"></i>
                <span>个人资料</span>
            </template>
            <el-menu-item-group>
                <el-menu-item index="/own/personal/profile" :route="{path:'/own/personal/profile'}">资料编辑</el-menu-item>
                <el-menu-item index="/own/personal/password" :route="{path:'/own/personal/password'}">修改密码</el-menu-item>
            </el-menu-item-group>
        </el-submenu>
    </el-menu>-->

    <ul class="nav-group">
      <li class="sub-item nav-item" index="index">
        <router-link to="/#home">
          <i class="el-icon-menu"></i>用户中心
        </router-link>
      </li>
    </ul>
    <ul class="nav-group">
      <li class="sub-item nav-item static-item">
        <i class="el-icon-edit"></i>软文发布
      </li>
      <li>
        <ul class="nav-group nav-group-sub">
          <li class="nav-item" index="publish">
            <router-link to="/own/publish">文章发布</router-link>
          </li>
          <li class="nav-item" index="resource-news">
            <router-link to="/own/news_order">文章列表</router-link>
          </li>
        </ul>
      </li>

    </ul>

    <ul class="nav-group">
      <li class="sub-item nav-item" index="cart">
        <router-link to="/cart?taxonomy=woa">
          <i class="el-icon-goods"></i>购物车
        </router-link>

      </li>
    </ul>

    <ul class="nav-group">
      <li class="sub-item nav-item" index="order">
        <router-link to="/own/order">
          <i class="el-icon-document"></i>订单中心
        </router-link>

      </li>
    </ul>
    <ul class="nav-group">
      <li class="sub-item nav-item" index="manuscript">
        <router-link to="/own/manuscripts">
          <i class="el-icon-setting"></i>稿件管理
        </router-link>

      </li>
    </ul>

    <!--<ul class="nav-group">
        <li class="sub-item nav-item" index="copy_write">
            <router-link to="/own/copy_write">
                <i class="el-icon-edit-outline"></i>稿件代写
            </router-link>
        </li>
    </ul>-->

    <ul class="nav-group">
      <li class="sub-item nav-item static-item">
        <i class="el-icon-edit-outline"></i>代写管理
      </li>
      <li>
        <ul class="nav-group nav-group-sub">
          <li class="nav-item" index="copy_write">
            <router-link to="/own/copy_write">
              文章代写
            </router-link>
          </li>
          <li class="nav-item" index="copy_write_list">
            <router-link to="/own/copy_write_list">
              代写列表
            </router-link>
          </li>
        </ul>
      </li>

    </ul>


    <ul class="nav-group">
      <li class="sub-item nav-item static-item">
        <i class="el-icon-sort"></i>充值与消费
      </li>
      <li>
        <ul class="nav-group nav-group-sub">
          <li class="nav-item" index="finance-make_recharge">
            <router-link to="/recharge_center">充值中心</router-link>
          </li>
          <li class="nav-item" index="finance-transaction">
            <router-link to="/own/finance/transaction">交易流水</router-link>
          </li>
          <!--<li class="nav-item" index="finance-invoice_list">
            <router-link to="/own/finance/invoice_list">发票列表</router-link>
          </li>
          <li class="nav-item" index="finance-invoice_info_list">
            <router-link to="/own/finance/invoice_info_list">发票信息审核</router-link>
          </li>-->
        </ul>
      </li>
    </ul>

    <ul class="nav-group">
      <li class="sub-item nav-item static-item">
        <i class="el-icon-tickets"></i>个人资料
      </li>
      <li>
        <ul class="nav-group nav-group-sub">
          <li class="nav-item" index="personal-profile">
            <router-link to="/own/personal/profile">资料编辑</router-link>
          </li>
          <!--<li class="nav-item" index="personal-mobile">
              <router-link to="/own/personal/mobile">修改手机号码</router-link>
          </li>-->
          <li class="nav-item" index="personal-password">
            <router-link to="/own/personal/password">修改密码</router-link>
          </li>
        </ul>
      </li>
    </ul>


    <!--<li index="/own/personal/profile">
        <i class="iconfont icon-xiugaiziliao"></i>
        <span slot="title">资料编辑</span>
    </li>
    <li index="/own/personal/mobile">
        <i class="iconfont icon-shoujihaoma"></i>
        <span slot="title">修改手机号码</span>
    </li>
    <li index="/own/personal/avatar">
        <i class="iconfont icon-yonghutouxiang"></i>
        <span slot="title">头像上传</span>
    </li>
    <li index="/own/personal/password">
        <i class="iconfont icon-xiugaimima"></i>
        <span slot="title">修改密码</span>
    </li>-->


  </div>
</template>
<script>
  export default {
    computed: {
      profile () {
        return this.$store.state.profile
      }
    },
    methods: {}
  }
</script>

<style>
  .ownper_left .router-link-exact-active, .ownper_left .router-link-active {
    outline: none;
    background-color: #e6f3fd;
  }
</style>

<style lang="css" scoped>

  .ownper_left {
    width: 210px;
    /*border-right: 1px solid #efefef;*/
    margin-right: 15px;
    background-color: #fff;
  }

  .nav_logo {
    margin-bottom: 30px;
  }

  .ownper_left >>> span {
    font-size: 14px;
  }

  .ownper_left .ownleft_ul {
    /* text-align: center; */
    color: #333333;
    font-size: 14px;
    float: left;
  }

  .ownper_left .ownleft_ul li {
    line-height: 40px;
    height: 40px;
  }

  .ownper_left .ownleft_ul li span {
    margin-left: 24px;
    font-size: 16px;
    font-weight: 400;
  }

  .ownper_left .ownleft_ul li > .own_arrow_right {
    margin-left: 32px;
    display: inline-block;
  }

  /* own-active 为选中的样式 */

  .ownper_left .ownleft_ul .own-active > li {
    width: 146px;
    border-left: 4px solid #f08c19;
  }

  .ownper_left .ownleft_ul .own-active > li > span {
    margin-left: 20px;
  }

  .ownper_right {
    width: 100%;
  }

  .ownper_box {
    min-height: 500px;
    padding-top: 24px;
    padding-bottom: 24px;
    margin-bottom: 24px;
    display: flex;
  }

  .show {
    height: auto !important;
  }

  .show > ul {
    padding-left: 39px;
    font-size: 14px;
  }

  .show > ul li {
    font-size: 14px;
    /* font-weight: 800; */
  }

  .on > li {
    color: #f08c19;
  }

  .on {
    color: #f08c19;
  }

  .show {
    height: auto !important;
  }

  .show .own_arrow_right {
    transform: rotate(90deg);
    transition: 0.5s;
  }

  .hide > ul {
    display: none;
  }

  .nav-group {
    margin-bottom: 5px;
  }

  .nav-group .nav-item {
    font-size: 14px;
    display: flex;
    align-items: center;
    height: 45px;
    line-height: 45px;
    color: #666;
  }

  .nav-group .sub-item {
    font-size: 16px;
  }

  .nav-group .sub-item.static-item {
    font-size: 16px;
    padding-left: 30px;
  }

  .nav-group .nav-item i {
    font-size: 20px;
    display: inline-block;
    width: 30px;
  }

  .nav-group .nav-item a {
    padding-left: 30px;
    display: block;
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-weight: 400;

  }

  .nav-group-sub .nav-item a {
    padding-left: 60px;
  }

</style>




// WEBPACK FOOTER //
// src/components/own/Left.vue